import React from "react"
import SbEditable from "storyblok-react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import ButtonGroup from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/ButtonGroup"
import useMediaQuery from "@yumgmbh/gatsby-theme-yum-components/src/hooks/useMediaQuery"

const MicroHeroBlock = ({ block }) => {
  const xl = useMediaQuery("(min-width: 1280px)")
  const md = useMediaQuery("(min-width: 640px)")

  return (
    <>
      {block.image?.filename?.length > 0 && (
        <SbEditable content={block}>
          <section>
            <div className="relative mx-auto block overflow-hidden">
              <Image
                image={block.image}
                title={block.title}
                alt={block.alt}
                aspectRatio={md && !xl ? "3by2" : xl ? "4by1" : "1by1"}
                className="object-cover w-full h-full"
              />
              <div className="absolute inset-0 bg-black bg-opacity-20">
                <div className="flex flex-col items-center justify-center w-full h-full max-w-screen-xl mx-auto text-center text-white pt-24 sm:pt-28">
                  <div className="max-w-screen-md px-grid">
                    {block.kicker?.length > 0 && (
                      <span className="text-base text-white kicker kicker-h1">
                        {block.kicker}
                      </span>
                    )}
                    {block.headline?.length > 0 && (
                      <h1
                        className="mt-2 md:mt-4 text-white headline headline-h1"
                        dangerouslySetInnerHTML={{
                          __html: block.headline.replace(/#/i, "<br />"),
                        }}
                      />
                    )}
                    {block.subheadline?.length > 0 && (
                      <div className="mt-2 md:mt-4">
                        <span className="inline subheadline subheadline-h1">
                          {block.subheadline}
                        </span>
                      </div>
                    )}
                  </div>
                  <ButtonGroup
                    className="mt-4 md:mt-8"
                    buttons={block.buttons}
                  />
                  {block.logo?.filename && (
                    <div className="absolute bottom-0 right-0 p-4 bg-white lg:bottom-auto">
                      <Image image={block.logo} className="block w-32 h-auto" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </SbEditable>
      )}
    </>
  )
}

export default MicroHeroBlock
